import React from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  return (
    <div className="whatsapp-floating">
      <span className="whatsapp-floating-label">
        ¿Necesitas ayuda?
      </span>

      <a
        href="https://wa.link/8proeq"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-floating-button"
        aria-label="Contactar con G&J Frío por WhatsApp"
        title="Escríbenos por WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>

        <span className="whatsapp-pulse"></span>
      </a>
    </div>
  );
};

export default WhatsAppButton;